// https://vuex.vuejs.org/en/actions.html

import NewApiService from "../../../utils/new.api.service";

export default {
  list(context, date) {
    return new Promise(resolve => {
      NewApiService.get("scheduler/available-slots?date="+date)
        .then(({ data }) => {      
          context.commit("set_events", data.events);
          resolve(data);
        })
    });
  },

  createReservation(context, reservations){
    return new Promise(resolve => {
        NewApiService.post("scheduler/reservations", {dates:reservations}).
        then(({data}) => {
            if(data.status =='toPaid'){
              context.commit("set_order", data.order)
              context.commit("set_reservation", data.reservations)
            }else if(data.status =='confirmation'){
              context.commit("set_reservation", data.reservations)
            }
            resolve(data)
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    })
  },

  setOrder(context, order){
    context.commit("set_order", order)
  },
  
  cancelReservation(context, reservationId){
    return new Promise(resolve => {
        NewApiService.delete("scheduler/reservations/"+ reservationId).
        then(({data}) => {
            resolve(data)
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    })
  },

  myReservations(context){
    return new Promise(resolve => {
      NewApiService.get("scheduler/reservations")
      .then(({data}) => {
          resolve(data)
      })
      .catch(({ response }) => {
        context.commit("set_error", response.data.errors);
      });
    })
  },
};
